<template>
  <div class="sidebar">
    <ul>
      <li class="sidebar-cell sidebar-phone">
        <a href="javascript:;"></a>
        <div class="box phone-box">
          <p>010-85927080</p>
        </div>
      </li>
      <li class="sidebar-cell sidebar-wechat">
        <a href="javascript:;"></a>
        <div class="box wechat-box">
          <p>微信扫一扫</p>
          <img :src="demo"
               alt="">
        </div>
      </li>
      <li class="sidebar-cell sidebar-user">
        <!--<router-link to="/personal"></router-link>-->
        <a href="javascript:;"></a>
        <div class="box user-box">
          <p>imc_china@emergency.co.jp</p>
        </div>
      </li>
      <li class="sidebar-cell sidebar-backtop">
        <a href="javascript:;"
           @click="backtoTop">回到<br/>顶部</a>
      </li>
    </ul>
  </div>
</template>
<script>
import demo from '@/assets/images/vip/qrcode.jpg'
export default {
  data () {
    return {
      demo
    }
  },
  methods: {
    backtoTop () {
      window.scrollTo(0, 0);
    }
  }
}
</script>
<style lang="less" scoped>
.sidebar {
  position: fixed;
  right: 30px;
  bottom: 8%;
  z-index: 102;
  width: 54px;
  ul li {
    position: relative;
    margin-bottom: 10px;
    // overflow: hidden;
  }
}
.sidebar-cell {
  // &:hover {
  //   .phone-box {
  //     width: 200px;
  //     height: auto;
  //     display: none;
  //     transform: translateX(-60px);
  //     transition: all 0.5s;
  //   }
  //   .wechat-box {
  //     width: 140px;
  //     height: auto;
  //     opacity: 1;
  //     transform: translateX(-60px);
  //     transition: all 0.5s;
  //     img {
  //       width: 120px;
  //       height: 120px;
  //     }
  //   }
  // }
  a {
    display: block;
    width: 54px;
    height: 54px;
    background: #fff;
    border: 2px solid #ae1e10;
    border-radius: 27px;
    background-repeat: no-repeat;
  }
}
.phone-box {
  position: absolute;
  z-index: 102;
  right: 64px;
  top: 0px;
  width: 229px;
  display: none;
  height: 54px;
  background: rgba(0, 0, 0, 0.5);
  border-radius: 27px;
  -webkit-transition: all 0.5s;
  transition: all 0.5s;
  p {
    color: #fff;
    font-size: 24px;
    line-height: 54px;
    text-align: center;
  }
}
.user-box {
  position: absolute;
  right: 64px;
  z-index: 102;
  top: -3px;
  width: 260px;
  display: none;
  height: 54px;
  background: rgba(0, 0, 0, 0.5);
  border-radius: 27px;
  -webkit-transition: all 0.5s;
  transition: all 0.5s;
  p {
    color: #fff;
    font-size: 18px;
    line-height: 54px;
    text-align: center;
  }
}
.wechat-box {
  position: absolute;
  right: 150px;
  top: -60px;
  z-index: 102;
  width: 77px;
  height: 80px;
  display: none;
  background: rgba(0, 0, 0, 0.5);
  border-radius: 8px;
  text-align: center;
  padding-bottom: 8px;
  -webkit-transition: all 0.5s;
  transition: all 0.5s;
  p {
    color: #fff;
    font-size: 14px;
    line-height: 18px;
  }
  img {
    width: 150px;
    height: 150px;
  }
}
.sidebar-phone {
  a {
    background-image: url('../assets/images/home/phone.png');
    background-position: 8px -38px;
    background-size: 60% auto;
  }
}
.sidebar-wechat {
  a {
    background-image: url('../assets/images/home/wechat.png');
    background-position: 8px -44px;
    background-size: 64% auto;
  }
}
.sidebar-user {
  a {
    background-image: url('../assets/images/home/user.jpg');
    background-position: -3px -3px;
  }
}
.sidebar-backtop {
  a {
    background: #ae1e10;
    color: #fff;
    font-size: 14px;
    line-height: 20px;
    text-align: center;
    padding-top: 6px;
  }
}
.sidebar-phone:hover .phone-box {
  display: block;
}
.sidebar-wechat:hover .wechat-box {
  display: block;
}
.sidebar-user:hover .user-box {
  display: block;
}
</style>